export default function BooleanIcon({ value, circle = false }) {
  if (value === null || value === undefined) {
    return null;
  }
  const icon = value
    ? `fas fa-${circle ? "check-circle" : "check"} text-success`
    : `fas fa-${circle ? "times-circle" : "times"} text-danger`;
  return <i className={icon} />;
}
